'use client';

import { useMemo } from 'react';
import { splitLessonMarkdown } from '@jeraisonne/db';
import type { ExerciseVisualBlock } from '@jeraisonne/ai/visual-blocks';
import { MarkdownMath } from './markdown-math';
import { VisualBlockRenderer } from './visual-blocks/visual-block-renderer';

/**
 * Markdown d'une leçon (KaTeX compris) + schémas ```jr-visual``` rendus en
 * figures. À utiliser partout où l'on affiche `lessons.content_md`.
 */
export function LessonMarkdown({ children, className }: { children: string; className?: string }) {
  const parts = useMemo(() => splitLessonMarkdown(children ?? ''), [children]);
  return (
    <div className={className}>
      {parts.map((p, i) => {
        if (p.kind === 'markdown') return <MarkdownMath key={i}>{p.md}</MarkdownMath>;
        if (p.kind === 'visual')
          return (
            <figure key={i} className="my-3 overflow-x-auto">
              <VisualBlockRenderer block={p.block as unknown as ExerciseVisualBlock} />
            </figure>
          );
        return (
          <p key={i} className="text-ink-400 my-2 text-xs italic">
            Schéma indisponible.
          </p>
        );
      })}
    </div>
  );
}
